import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const AttendanceCircularIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon
      width={60}
      height={61}
      viewBox="0 0 60 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_503_1988)">
        <circle cx="16.25" cy="10.5" r="4" fill="white" />
        <circle cx="16.25" cy="36" r="4" fill="white" />
        <circle cx="30.25" cy="40.5" r="4" fill="white" />
        <circle cx="30.25" cy="23.5" r="4" fill="white" />
        <circle cx="30.25" cy="4.5" r="4" fill="white" />
        <circle cx="43.75" cy="10.5" r="4" fill="white" />
        <circle cx="43.75" cy="36" r="4" fill="white" />
        <circle cx="47.75" cy="23.5" r="4" fill="white" />
        <circle cx="12.25" cy="23.5" r="4" fill="white" />
        <line x1="30.5897" y1="23.1331" x2="44.0897" y2="35.6331" stroke="white" strokeDasharray="2 2" />
        <line x1="29.75" y1="23.5" x2="29.75" y2="4.5" stroke="white" strokeDasharray="2 2" />
        <line x1="16.053" y1="10.0404" x2="30.053" y2="4.04043" stroke="white" strokeDasharray="2 2" />
        <line x1="30.5971" y1="22.8599" x2="16.5971" y2="36.3599" stroke="white" strokeDasharray="2 2" />
        <line x1="12.7262" y1="23.3476" x2="16.7262" y2="35.8476" stroke="white" strokeDasharray="2 2" />
        <line x1="30.097" y1="40.976" x2="16.097" y2="36.476" stroke="white" strokeDasharray="2 2" />
        <line x1="48.2262" y1="23.6524" x2="44.2262" y2="36.1524" stroke="white" strokeDasharray="2 2" />
        <line x1="47.2721" y1="23.647" x2="43.2721" y2="10.647" stroke="white" strokeDasharray="2 2" />
      </g>
      <defs>
        <clipPath id="clip0_503_1988">
          <rect width="60" height="60" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default AttendanceCircularIcon;
